<script setup lang="ts"></script>

<template>
  <div class="px-8 md:pb-0">
    <div class="grid grid-cols-1 lg:grid-cols-1 lg:ml-0 lg:mr-0 lg:gap-4">
      <div class="mt-20">
        <p class="text-base lg:text-start lg:text-[25px]">
          Fystesterna består av 4 enkla övningar som alla klarar av.
        </p>
        <p class="text-lg lg:text-start lg:text-[22px] lg:w-[80%]">
          Varje övning kommer att ha en kort film som snabbt visar hur
          den ska utföras.
        </p>
        <!-- <div class="lg:w-[80%] lg:mt-[5%]">
          <b-video video-id="u3oakKQ1eUNHYbPWfsQQocdVYrAyzF02i4ht7902VHJjw" />
        </div> -->
      </div>
    </div>
  </div>
</template>
